"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectRTBXClient = void 0;
const app_module_1 = require("./app.module");
const token_service_1 = require("./token.service");
const baseURL = "/connect-management/rtbx/client";
class ConnectRTBXClient {
    constructor(params) {
        Object.assign(this, params);
    }
    static get(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let http = app_module_1.AppModule.injector.get(token_service_1.TokenService);
                let response = yield http.get(`${baseURL}/${id}`).toPromise();
                let json = yield response.json();
                let client = new ConnectRTBXClient(json);
                return client;
            }
            catch (err) {
                let json = yield err.json();
                throw json;
            }
        });
    }
}
exports.ConnectRTBXClient = ConnectRTBXClient;
//# sourceMappingURL=connect-rtbx-client.js.map